import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import icon from "./log-menu.png";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";
import { darken, getContrast, lighten, readableColor } from "polished";

const validColor = (value, fallback) => {
  try {
    getContrast(value, "#ffffff");
    return value;
  } catch {
    return fallback;
  }
};

export const CustomDialog = ({
  open,
  onConfirm,
  onCancel,
  title,
  message = null,
  confirm = "Confirmar",
  moodle,
  cancel = "Cancelar",
  courseid,
  countdown = false,
}) => {
  const [count, setCount] = useState(15);
  const navigate = useNavigate();
  let interval = null;

  const theme = useTheme();
  const config = useConfig();
  const surfaceColor = validColor(
    theme.colors.backgroundColorBody || theme.colors[`background_${theme.mode}`],
    theme.mode === "dark" ? "#0f2844" : "#ffffff"
  );
  const surfaceTextColor = readableColor(surfaceColor);
  const configuredButtonColor = validColor(
    theme.colors[`button_${theme.mode}`],
    surfaceTextColor
  );
  const buttonColor = getContrast(configuredButtonColor, surfaceColor) >= 1.5
    ? configuredButtonColor
    : surfaceTextColor;
  const configuredTextColor = validColor(
    theme.colors[`text_button_${theme.mode}`],
    readableColor(buttonColor)
  );
  const buttonTextColor = getContrast(configuredTextColor, buttonColor) >= 4.5
    ? configuredTextColor
    : readableColor(buttonColor);
  const hoverColor = readableColor(buttonColor) === "#fff"
    ? lighten(0.1, buttonColor)
    : darken(0.1, buttonColor);
  const buttonStyles = {
    fontSize: "1.4rem",
    fontFamily: "Pop-Medium",
    color: buttonTextColor,
    backgroundColor: buttonColor,
    border: getContrast(buttonColor, surfaceColor) < 3 ? `1px solid ${surfaceTextColor}` : "1px solid transparent",
    "&:hover": {
      backgroundColor: hoverColor,
      color: readableColor(hoverColor),
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${surfaceTextColor}`,
      outlineOffset: "3px",
    },
  };

  React.useEffect(() => {
    if (countdown && open) {
      if (count === 0) {
        setCount(null);
        navigate(`/detailcourse/${moodle.courses[0].id}`);
      }

      if (!count) return;

      interval = setInterval(() => {
        let newcount = count - 1;
        setCount(newcount);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [count]);

  return (
    <>
      <Dialog
        open={open}
        fullWidth
        maxWidth={"xs"}
        PaperProps={{
          style: {
            backgroundColor: surfaceColor,
            boxShadow: "none",
            paddingBottom: ".7rem",
            paddingRight: ".9rem",
          },
        }}
      >
        <DialogTitle
          sx={{ fontSize: "2rem", fontFamily: "Pop-Regular" }}
        >
          <img
            src={config.config.theme.logo}
            style={{ width: 90, marginTop: "1rem" }}
            alt={"..."}
          />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              color: surfaceTextColor,
              fontSize: "1.6rem",
              fontFamily: "Pop-Regular",
              marginLeft: ".2rem",
            }}
          >
            {message
              ? message
              : countdown
              ? ` Se redirigira a iniciar sesión en SENCE en ${count} segundos `
              : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={buttonStyles}
          >
            {confirm}
          </Button>
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              fontSize: "1.4rem",
              fontFamily: "Pop-Medium",
              color: surfaceTextColor,
              borderColor: surfaceTextColor,
              "&:hover": { borderColor: surfaceTextColor, backgroundColor: surfaceTextColor === "#fff" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)" },
              "&.Mui-focusVisible": { outline: `2px solid ${surfaceTextColor}`, outlineOffset: "3px" },
            }}
          >
            {cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
